/* Dryland Pasture product page behaviour.
   Loaded on templates/product.dryland-pasture.json only.

   Everything here drives presentation on top of Dawn's own components; the
   add-to-cart path still goes through Dawn's <product-form>, so cart state,
   the cart notification and the cart count keep working unchanged. */
(function () {
  'use strict';

  // The page spans several sections, so scope to the document and simply
  // bail when this template's buy column is not present.
  if (!document.querySelector('[data-dp-buy]')) return;

  var root = document;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------------------------------------------------------------- helpers */

  // Dawn re-renders the buy column on variant change, so look these up lazily
  // rather than caching a node that may have been replaced.
  function qtyInput() {
    return document.querySelector('[data-dp-buy] .quantity__input');
  }
  function submitButton() {
    return document.querySelector('[data-dp-buy] .product-form__submit');
  }
  function unitPrice() {
    var el = document.querySelector('[data-dp-buy] [data-dp-price]');
    return el ? parseInt(el.dataset.dpPrice, 10) : 0;
  }
  function currentQty() {
    var el = qtyInput();
    var n = el ? parseInt(el.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  /* ------------------------------------------------------------- calculator */

  var calc = root.querySelector('[data-dp-calc]');
  if (calc) {
    // Rates, unit and bag size come from the section (metafields first, then
    // block settings) as data attributes, so the same script serves every
    // product. RATES looks like {drill:[lo,hi], broadcast:[lo,hi]} with any
    // method the product lacks simply absent.
    var RATES = {};
    try { RATES = JSON.parse(calc.dataset.dpRates || '{}'); } catch (e) { RATES = {}; }
    delete RATES._;
    // Base methods are the dryland ones; alfalfa adds irrigated_* variants.
    var METHODS = Object.keys(RATES).filter(function (k) { return k.indexOf('irrigated_') !== 0; });
    if (!METHODS.length) METHODS = Object.keys(RATES).map(function (k) { return k.replace('irrigated_', ''); });
    if (!METHODS.length) return;

    var BAG_LB = parseFloat(calc.dataset.dpBagLb) || 25;
    var UNIT = calc.dataset.dpUnit === '1000sqft' ? '1000sqft' : 'acre';
    var VARIANT_WEIGHTS = [];
    try {
      VARIANT_WEIGHTS = JSON.parse(calc.dataset.dpVariantWeights || '[]');
    } catch (e) {
      VARIANT_WEIGHTS = [];
    }
    VARIANT_WEIGHTS = VARIANT_WEIGHTS
      .filter(function (v) { return v && Number(v.weight) > 0; })
      .map(function (v) { return { id: Number(v.id), weight: Number(v.weight) }; })
      .sort(function (a, b) { return a.weight - b.weight; });

    var acresEl = calc.querySelector('[data-dp-acres]');
    var methodEl = calc.querySelector('[data-dp-method]'); // absent when only one method
    var groundEl = calc.querySelector('[data-dp-ground]'); // alfalfa only
    var bagsEl = calc.querySelector('[data-dp-bags]');
    var lbsEl = calc.querySelector('[data-dp-lbs]');
    var applyEl = calc.querySelector('[data-dp-apply]');
    var bagsHi = 1;

    var currentMethod = function () {
      if (!methodEl) return METHODS[0];
      var checked = methodEl.querySelector('input:checked');
      var m = checked ? checked.value : methodEl.value;
      return METHODS.indexOf(m) >= 0 ? m : METHODS[0];
    };
    // Resolve the rate for the chosen ground + method, falling back to
    // whichever variant of that method exists.
    var currentRate = function () {
      var m = currentMethod();
      var irrigated = groundEl && (groundEl.querySelector('input:checked') || {}).value === 'irrigated';
      var key = irrigated ? 'irrigated_' + m : m;
      return RATES[key] || RATES[m] || RATES['irrigated_' + m];
    };

    var fmt = function (n) {
      return Number(n).toLocaleString('en-US', { maximumFractionDigits: 1 });
    };

    // A larger bag that would need fewer bags for this area, if any. Only a
    // hint: the calculator never changes the shopper's selected variant.
    // (An earlier "auto-upgrade" wrote the bigger bag's id straight into the
    // form's hidden input while the picker, price and title still showed the
    // smaller one, so Add to cart added the wrong size. Never reintroduce.)
    var largerBagHint = function (requiredLb) {
      if (VARIANT_WEIGHTS.length < 2) return '';
      var currentCount = Math.ceil(requiredLb / BAG_LB);
      var candidates = VARIANT_WEIGHTS
        .filter(function (v) { return v.weight > BAG_LB; })
        .map(function (v) {
          return { weight: v.weight, count: Math.ceil(requiredLb / v.weight) };
        })
        .filter(function (v) { return v.count < currentCount; })
        .sort(function (a, b) { return a.count - b.count || a.weight - b.weight; });
      if (!candidates.length) return '';
      var c = candidates[0];
      return ' (or ' + c.count + ' × ' + fmt(c.weight) + ' lb ' + (c.count === 1 ? 'bag' : 'bags') + ')';
    };

    var renderCalc = function () {
      var area = Math.max(1, parseFloat(acresEl.value) || 1);
      var rate = currentRate();
      if (!rate) return;
      // Rates are per acre or per 1,000 sq ft; normalise the area to that unit.
      var units = UNIT === '1000sqft' ? area / 1000 : area;
      var lbsLo = units * rate[0];
      var lbsHi = units * rate[1];
      var bagsLo = Math.ceil(lbsLo / BAG_LB);
      bagsHi = Math.ceil(lbsHi / BAG_LB);

      var bags = bagsLo === bagsHi ? bagsHi + (bagsHi === 1 ? ' bag' : ' bags') : bagsLo + '–' + bagsHi + ' bags';
      var areaLabel = UNIT === '1000sqft'
        ? fmt(area) + ' sq ft'
        : fmt(area) + ' acre' + (area === 1 ? '' : 's');
      var perLabel = UNIT === '1000sqft' ? 'lbs/1,000 sq ft' : 'lbs/acre';

      var range = function (lo, hi) { return lo === hi ? fmt(hi) : fmt(lo) + '–' + fmt(hi); };
      bagsEl.textContent = bags + ' for ' + areaLabel + largerBagHint(lbsHi);
      lbsEl.textContent = range(lbsLo, lbsHi) + ' lb of seed at ' + range(rate[0], rate[1]) + ' ' + perLabel;
      applyEl.textContent = 'Set quantity to ' + bagsHi;
    };

    acresEl.addEventListener('input', renderCalc);
    if (methodEl) methodEl.addEventListener('change', renderCalc);
    if (groundEl) groundEl.addEventListener('change', renderCalc);

    // Dawn swaps price/buy-button markup on variant change but not custom
    // blocks, so pick the new bag weight up from its pub/sub event. Variant
    // weight in the product JSON is grams.
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function (event) {
        var v = event && event.data && event.data.variant;
        if (v && v.weight > 0) {
          BAG_LB = Math.round((v.weight / 453.592) * 100) / 100;
          renderCalc();
        }
      });
    }
    applyEl.addEventListener('click', function () {
      var el = qtyInput();
      if (!el) return;
      el.value = bagsHi;
      // Dawn listens for change to refresh volume pricing and the cart rules.
      el.dispatchEvent(new Event('change', { bubbles: true }));
      syncQty();
      setCalcModal(false);
    });

    /* ------------------------------------------------------ calculator pop-up */
    // Centred modal over a dimmed page; opened from the trigger box in the
    // buy column. Scroll is locked while it is open.
    var calcModal = root.querySelector('[data-dp-calc-modal]');
    var calcTrigger = root.querySelector('[data-dp-calc-open]');
    function setCalcModal(open) {
      if (!calcModal) return;
      calcModal.dataset.open = open ? 'true' : 'false';
      document.body.style.overflow = open ? 'hidden' : '';
      if (calcTrigger) calcTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var field = calcModal.querySelector('[data-dp-acres]');
        if (field) field.focus({ preventScroll: true });
      } else if (calcTrigger) {
        calcTrigger.focus();
      }
    }
    if (calcModal && calcTrigger) {
      calcTrigger.addEventListener('click', function () {
        setCalcModal(true);
      });
      calcModal.addEventListener('click', function (e) {
        if (e.target.closest('[data-dp-calc-close]')) setCalcModal(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && calcModal.dataset.open === 'true') setCalcModal(false);
      });
    }
    renderCalc();
  }

  /* ------------------------------------------- add-to-cart label + qty sync */

  var stickyQty = root.querySelector('[data-dp-sticky-qty]');
  var stickyAtc = root.querySelector('[data-dp-sticky-atc]');
  var stickyVariant = root.querySelector('[data-dp-sticky-variant]');
  var addedTimer = null;

  // Label is a plain "Add to cart"; the running total lives in the price row
  // and the cart, so it is not repeated on the button.
  function atcLabel() {
    return 'Add to cart';
  }

  function syncQty() {
    var qty = currentQty();
    var main = submitButton();
    // Leave the "Added" confirmation and any sold-out label alone.
    if (main && !main.dataset.dpAdded) {
      var span = main.querySelector('span');
      if (span && main.getAttribute('aria-disabled') !== 'true' && !main.disabled) {
        span.textContent = atcLabel();
      }
    }
    if (stickyQty && document.activeElement !== stickyQty) stickyQty.value = qty;
    if (stickyAtc) stickyAtc.textContent = atcLabel();
  }

  if (typeof subscribe === 'function') {
    subscribe('variant-change', function (event) {
      var v = event && event.data && event.data.variant;
      if (!v) return;
      var hook = document.querySelector('[data-dp-buy] [data-dp-price]');
      if (hook) hook.dataset.dpPrice = v.price;
      var block = document.querySelector('[data-dp-buy] [data-dp-price-block]');
      if (block) {
        var amount = block.querySelector('.dp-price__amount');
        var meta = block.querySelector('.dp-price__meta');
        if (amount) amount.textContent = money(v.price);
        if (meta && v.weight > 0) {
          var lb = Math.round((v.weight / 453.592) * 10) / 10;
          var suffix = block.dataset.dpUnitSuffix || 'lb';
          meta.textContent = lb + ' ' + suffix + ' bag · ' + money(Math.round(v.price / lb)) + ' / ' + suffix;
        }
      }
      var stickyPrice = document.querySelector('[data-dp-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      var stickyTitle = document.querySelector('[data-dp-sticky-title]');
      if (stickyTitle) {
        var vt = v.title && !/Default/.test(v.title) ? ' (' + v.title + ')' : '';
        stickyTitle.textContent = stickyTitle.dataset.dpProductTitle + vt;
      }
      if (stickyVariant && v.title && stickyVariant.value !== v.title) stickyVariant.value = v.title;
      syncQty();
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-dp-buy] .quantity__input')) syncQty();
  });
  document.addEventListener('input', function (e) {
    if (e.target.closest('[data-dp-buy] .quantity__input')) syncQty();
  });
  // Dawn's quantity +/- buttons write the value without firing input events.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-dp-buy] .quantity__button')) setTimeout(syncQty, 0);
  });

  if (stickyQty) {
    stickyQty.addEventListener('change', function () {
      var n = Math.max(1, parseInt(stickyQty.value, 10) || 1);
      stickyQty.value = n;
      var el = qtyInput();
      if (el) {
        el.value = n;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncQty();
    });
  }

  if (stickyVariant) {
    // Mirror the bar's bag-size selector onto Dawn's variant picker (radio
    // pills or dropdown); Dawn then publishes variant-change, which updates
    // the bar's title and price above.
    stickyVariant.addEventListener('change', function () {
      var title = stickyVariant.value;
      var picker = document.querySelector('[data-dp-buy] variant-selects');
      if (!picker) return;
      var radio = Array.prototype.find.call(picker.querySelectorAll('input[type="radio"]'), function (r) {
        return r.value === title;
      });
      if (radio) {
        if (!radio.checked) radio.click();
        return;
      }
      var select = picker.querySelector('select');
      if (select && select.value !== title) {
        select.value = title;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* Phones: the pinned button must not add a size the shopper never chose.
     Until a size has been picked on this page view, tapping it opens the
     size sheet instead; tapping a size there selects that variant through
     Dawn's picker, confirms the form carries that variant id, then submits.
     Desktop has the bar's own selector, so it adds straight away. */
  var sizePicker = document.querySelector('[data-dp-buy] variant-selects');
  var sizeSheet = root.querySelector('[data-dp-size-sheet]');
  var sizeChosen = /[?&]variant=/.test(window.location.search);
  var sizeBusy = false;
  if (sizePicker) {
    sizePicker.addEventListener('change', function () {
      sizeChosen = true;
    });
  }
  if (stickyVariant) {
    stickyVariant.addEventListener('change', function () {
      sizeChosen = true;
    });
  }
  function needsSizeSheet() {
    return !!sizeSheet && !sizeChosen && !isDesktop();
  }
  function setSizeSheet(open) {
    if (!sizeSheet) return;
    sizeSheet.dataset.open = open ? 'true' : 'false';
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      var first = sizeSheet.querySelector('[data-dp-size-pick]:not([disabled])');
      if (first) first.focus();
    } else if (stickyAtc) {
      stickyAtc.focus();
    }
  }
  function formVariantId() {
    var input = document.querySelector('[data-dp-buy] product-form input[name="id"]');
    return input ? String(input.value) : '';
  }
  // Select one option value through the live picker (radio pills or
  // dropdown). Dawn re-renders the picker after each change, so the picker
  // is re-queried every time.
  function pickOption(index, value) {
    var picker = document.querySelector('[data-dp-buy] variant-selects');
    if (!picker) return false;
    var fields = picker.querySelectorAll('.product-form__input');
    var field = fields[index] || picker;
    var radio = Array.prototype.find.call(field.querySelectorAll('input[type="radio"]'), function (r) {
      return r.value === value;
    });
    if (radio) {
      if (!radio.checked) radio.click();
      return true;
    }
    var select = field.querySelector('select');
    if (select) {
      if (select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }
    return false;
  }
  // Resolve once the form carries the target variant id (Dawn swaps the
  // hidden input after its section fetch), or give up after the timeout.
  function waitForVariant(id, timeout) {
    return new Promise(function (resolve) {
      var started = Date.now();
      (function poll() {
        if (formVariantId() === String(id)) return resolve(true);
        if (Date.now() - started > timeout) return resolve(false);
        setTimeout(poll, 60);
      })();
    });
  }
  function selectVariantAndAdd(pill) {
    if (sizeBusy) return;
    var id = pill.dataset.dpSizePick;
    var values = (pill.dataset.options || '').split('|');
    sizeBusy = true;
    sizeSheet.querySelectorAll('[data-dp-size-pick]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === pill ? 'true' : 'false');
    });
    pill.classList.add('is-busy');
    var chain = Promise.resolve();
    values.forEach(function (value, i) {
      chain = chain.then(function () {
        pickOption(i, value);
        // Let Dawn process this option before the next one (multi-option
        // products); the final check below is what matters.
        return new Promise(function (r) { setTimeout(r, values.length > 1 ? 700 : 0); });
      });
    });
    chain.then(function () {
      return waitForVariant(id, 4000);
    }).then(function (ok) {
      pill.classList.remove('is-busy');
      sizeBusy = false;
      if (!ok) {
        pill.setAttribute('aria-pressed', 'false');
        return;
      }
      sizeChosen = true;
      setSizeSheet(false);
      var main = submitButton();
      if (main) main.click();
    });
  }
  if (sizeSheet) {
    sizeSheet.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-dp-size-pick]');
      if (pill && !pill.disabled) {
        selectVariantAndAdd(pill);
        return;
      }
      if (e.target.closest('[data-dp-size-sheet-close]')) setSizeSheet(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sizeSheet.dataset.open === 'true') setSizeSheet(false);
    });
  }

  if (stickyAtc) {
    // Delegate to the real form so Dawn owns the cart request.
    stickyAtc.addEventListener('click', function () {
      if (needsSizeSheet()) {
        setSizeSheet(true);
        return;
      }
      var main = submitButton();
      if (main) main.click();
    });
  }

  // Dawn dispatches this after a successful /cart/add.js from <product-form>.
  document.addEventListener('cart:update', flagAdded);
  document.addEventListener('cart-notification:show', flagAdded);

  function flagAdded() {
    var main = submitButton();
    if (!main) return;
    var span = main.querySelector('span');
    main.dataset.dpAdded = 'true';
    if (span) span.textContent = 'Added ✓';
    if (stickyAtc) stickyAtc.textContent = 'Added ✓';
    clearTimeout(addedTimer);
    addedTimer = setTimeout(function () {
      delete main.dataset.dpAdded;
      syncQty();
    }, 1600);
  }

  syncQty();

  /* ----------------------------------------------------------- sticky bar */

  var sticky = root.querySelector('[data-dp-sticky]');
  var buySection = document.querySelector('[data-dp-buy]');
  var scrolledPastBuy = false;

  // Desktop drawers are non-modal side panels; mobile keeps the bottom sheet
  // with scrim and scroll lock. Evaluated at call time so a resize mid-session
  // still does the right thing.
  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  // Sticky bar visibility has two inputs: scroll position, and whether a
  // desktop drawer is open. The drawer covers the buy column on desktop, so
  // the bar is the guaranteed route to Add to cart while it is open.
  function updateSticky() {
    if (!sticky) return;
    var drawerOpenDesktop = !!openDrawer && isDesktop();
    // Desktop: the right-hand panel covers the buy column at laptop widths,
    // so keep the bar up as the Add to cart route while a drawer is open.
    // Mobile: hidden under the bottom sheet.
    var show = drawerOpenDesktop || (scrolledPastBuy && !openDrawer);
    sticky.dataset.stuck = show ? 'true' : 'false';
    sticky.dataset.drawerOpen = drawerOpenDesktop ? 'true' : 'false';
  }

  if (sticky && buySection) {
    // Show the bar once the buy buttons (Add to cart + Buy with Shop) have
    // scrolled past the top of the viewport, so it appears as soon as they
    // are out of sight rather than after the whole buy column. A scroll
    // check (one getBoundingClientRect per animation frame) rather than an
    // IntersectionObserver: the buttons are short, and a jump such as
    // scrollTo(0, 0) or a fast flick can move them from above the viewport
    // to below it without ever crossing it, which an observer never reports.
    var buyButtons = buySection.querySelector('.product-form__buttons') || buySection;
    // Phones keep the bar on screen at all times except while the footer is
    // in view (the CSS reads data-footer); the whole footer group counts.
    var footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
    var stickyTick = false;
    function checkBuyButtons() {
      stickyTick = false;
      scrolledPastBuy = buyButtons.getBoundingClientRect().bottom < 0;
      if (footer) sticky.dataset.footer = footer.getBoundingClientRect().top < window.innerHeight ? 'true' : 'false';
      updateSticky();
    }
    function onScroll() {
      if (stickyTick) return;
      stickyTick = true;
      window.requestAnimationFrame(checkBuyButtons);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    checkBuyButtons();
  }

  /* -------------------------------------------------------------- drawers */

  var openDrawer = null;
  var lastTrigger = null;

  function setDrawer(name) {
    // Moving straight from one drawer to another should swap the contents,
    // not slide the old panel out and the new one in past each other.
    var switching = !!(openDrawer && name && openDrawer !== name);

    root.querySelectorAll('[data-dp-drawer]').forEach(function (d) {
      if (switching) d.dataset.switching = 'true';
      d.dataset.open = d.dataset.dpDrawer === name ? 'true' : 'false';
    });

    if (switching) {
      // Drop the flag on the next frame so normal open/close still animates.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.querySelectorAll('[data-dp-drawer]').forEach(function (d) {
            delete d.dataset.switching;
          });
        });
      });
    }

    root.querySelectorAll('[data-dp-tab]').forEach(function (t) {
      t.setAttribute('aria-selected', t.dataset.dpTab === name ? 'true' : 'false');
    });

    openDrawer = name;

    var modal = !!name && !isDesktop();
    document.body.style.overflow = modal ? 'hidden' : '';
    root.querySelectorAll('[data-dp-drawer]').forEach(function (d) {
      d.setAttribute('aria-modal', modal ? 'true' : 'false');
      d.dataset.modal = modal ? 'true' : 'false';
    });
    updateSticky();

    if (name && !switching) {
      var panel = root.querySelector('[data-dp-drawer="' + name + '"]');
      var close = panel && panel.querySelector('[data-dp-drawer-close]');
      if (close) close.focus();
    } else if (!name && lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  root.addEventListener('click', function (e) {
    var open = e.target.closest('[data-dp-drawer-open]');
    if (open) {
      if (!open.dataset.dpTab) lastTrigger = open;
      setDrawer(open.dataset.dpDrawerOpen);
      return;
    }
    if (e.target.closest('[data-dp-drawer-close]') || e.target.closest('[data-dp-drawer-scrim]')) {
      setDrawer(null);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) setDrawer(null);
  });

  window.matchMedia('(min-width: 750px)').addEventListener('change', function () {
    if (openDrawer) setDrawer(openDrawer);
    else updateSticky();
  });

  /* --------------------------------------------------------- gallery arrows */

  // Dawn only shows media arrows on mobile for this gallery layout. Rather
  // than fork the shared product-media-gallery snippet, add the two round
  // buttons here and drive them through Dawn's own thumbnail buttons so the
  // active-media bookkeeping stays in one place.
  (function () {
    // Seed-mix layout only: the arrows are styled under .dp-buy, and a
    // standard Dawn buy column (sticky bar on its own) must stay untouched.
    var gallery = document.querySelector('.dp-buy media-gallery');
    if (!gallery) return;

    var viewer = gallery.querySelector('.product__media-list');
    if (!viewer || !viewer.parentElement) return;

    function thumbs() {
      return Array.prototype.slice.call(
        gallery.querySelectorAll('.thumbnail-list__item:not(.thumbnail-list_item--variant) .thumbnail')
      );
    }
    if (thumbs().length < 2) return;

    var frame = viewer.parentElement;
    frame.classList.add('dp-gallery');

    function make(dir, label, path) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dp-gallery__nav dp-gallery__nav--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML =
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
        '<path d="' + path + '" stroke="currentColor" stroke-width="1.75" ' +
        'stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', function () {
        var list = thumbs();
        var i = list.findIndex(function (t) {
          return t.getAttribute('aria-current') === 'true';
        });
        if (i < 0) i = 0;
        var next = dir === 'prev' ? (i - 1 + list.length) % list.length : (i + 1) % list.length;
        list[next].click();
      });
      return b;
    }

    frame.appendChild(make('prev', 'Previous image', 'M10 2L4 8l6 6'));
    frame.appendChild(make('next', 'Next image', 'M6 2l6 6-6 6'));
  })();

  /* ------------------------------------------------------- rating -> reviews */

  // Judge.me renders into a generated block id, so there is no stable anchor
  // to point the stars at. Find the widget at click time and scroll to it.
  root.addEventListener('click', function (e) {
    var link = e.target.closest('.dp-rating');
    if (!link) return;

    var widget = document.querySelector(
      '[id*="judge_me_reviews"], .jdgm-rev-widg, .jdgm-widget, #judgeme_product_reviews'
    );
    if (!widget) return; // fall through to the href

    e.preventDefault();
    widget.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  });

  /* ------------------------------------------------------------------ FAQ */

  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-dp-faq-q]');
    if (!q) return;
    var wasOpen = q.getAttribute('aria-expanded') === 'true';
    // Exclusive accordion: opening one closes the rest.
    root.querySelectorAll('[data-dp-faq-q]').forEach(function (other) {
      other.setAttribute('aria-expanded', 'false');
    });
    q.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
  });
})();
